(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1312],{

/***/ 6821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in",
      function () {
        return __webpack_require__(69815);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(34289);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _appPath__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79973);
/* harmony import */ var _auth_components_AuthFooter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30309);
/* harmony import */ var _auth_components_AuthLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1941);
/* harmony import */ var _auth_components_EmailConfirmation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81730);
/* harmony import */ var _auth_components_ExternalSignIn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65160);
/* harmony import */ var _auth_components_GeneralFormError__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10102);
/* harmony import */ var _auth_hooks_useSignIn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25476);
/* harmony import */ var _auth_withPublicOnly__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94889);
/* harmony import */ var _main_components_buttons_BusyBtn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85324);
/* harmony import */ var _main_components_HrWithText__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4395);
/* harmony import */ var _main_components_Layout__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(19232);
/* harmony import */ var _main_components_NvCaptcha__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7344);
/* harmony import */ var _main_utils_boolProp__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(10612);
/* harmony import */ var _main_utils_globalConst__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52806);























var validationSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry({
    id: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required().min(_main_utils_globalConst__WEBPACK_IMPORTED_MODULE_18__/* .USERNAME_MIN_LENGTH */ .Xs),
    password: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required()
});
var SignInPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isDisabled = ref[0], setIsDisabled = ref[1];
    var captchaRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), password = ref1[0], setPassword = ref1[1];
    var ref2 = (0,_auth_hooks_useSignIn__WEBPACK_IMPORTED_MODULE_12__/* .useSignIn */ .z)(), notConfirmedEmail = ref2.notConfirmedEmail, isProcessing = ref2.isProcessing, errorMsg = ref2.errorMsg, clearError = ref2.clearError, login = ref2.login;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    function handleSubmit(data) {
        return _handleSubmit.apply(this, arguments);
    }
    function _handleSubmit() {
        _handleSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(data) {
            var reCaptchaToken;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPassword(data.password);
                        return [
                            4,
                            captchaRef.current.execute()
                        ];
                    case 1:
                        reCaptchaToken = _state.sent();
                        return [
                            4,
                            login(data.id, data.password, reCaptchaToken)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSubmit.apply(this, arguments);
    }
    function handleEmailConfirmed() {
        return _handleEmailConfirmed.apply(this, arguments);
    }
    function _handleEmailConfirmed() {
        _handleEmailConfirmed = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
            var reCaptchaToken, success;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            captchaRef.current.execute()
                        ];
                    case 1:
                        reCaptchaToken = _state.sent();
                        return [
                            4,
                            login(notConfirmedEmail, password, reCaptchaToken)
                        ];
                    case 2:
                        success = _state.sent();
                        if (!success) {
                            router.replace("/");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleEmailConfirmed.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_main_components_Layout__WEBPACK_IMPORTED_MODULE_16__/* .Layout */ .A, {
        title: "Sign in",
        description: "Sign in to Nostwave with your login, Google or Facebook account.",
        noNavigation: true,
        fullPage: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_main_components_NvCaptcha__WEBPACK_IMPORTED_MODULE_17__/* .NvCaptcha */ .t, {
                ref: captchaRef
            }),
            notConfirmedEmail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_auth_components_EmailConfirmation__WEBPACK_IMPORTED_MODULE_9__/* .EmailConfirmation */ .t, {
                email: notConfirmedEmail,
                onConfirmed: handleEmailConfirmed,
                resendEnabled: true
            }),
            !notConfirmedEmail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_auth_components_AuthLayout__WEBPACK_IMPORTED_MODULE_8__/* .AuthLayout */ .g, {
                header: "Sign in with username or email",
                footer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_auth_components_AuthFooter__WEBPACK_IMPORTED_MODULE_7__/* .AuthFooter */ .x, {
                    page: "signIn"
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                        validationSchema: validationSchema,
                        onSubmit: function(values) {
                            return handleSubmit(values);
                        },
                        initialValues: {
                            id: "",
                            password: ""
                        },
                        children: function(param) {
                            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, setFieldTouched = param.setFieldTouched;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                noValidate: true,
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("fieldset", {
                                        disabled: isProcessing || isDisabled,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "d-grid gap-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__/* ["default"].Group */ .Z.Group, {
                                                    controlId: "id",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__/* ["default"].Control */ .Z.Control, {
                                                            type: "text",
                                                            autoComplete: "username",
                                                            inputMode: "email",
                                                            placeholder: "Username or email address",
                                                            onChange: handleChange,
                                                            onBlur: function() {
                                                                return setFieldTouched("id");
                                                            },
                                                            isInvalid: touched.id && !!errors.id,
                                                            maxLength: _main_utils_globalConst__WEBPACK_IMPORTED_MODULE_18__/* .EMAIL_MAX_LENGTH */ .bV
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                                                            type: "invalid",
                                                            children: "Username or email is required."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__/* ["default"].Group */ .Z.Group, {
                                                    controlId: "password",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__/* ["default"].Control */ .Z.Control, {
                                                            type: "password",
                                                            autoComplete: "current-password",
                                                            placeholder: "Password",
                                                            onChange: handleChange,
                                                            onBlur: function() {
                                                                return setFieldTouched("password");
                                                            },
                                                            isInvalid: touched.password && !!errors.password
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_21__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                                                            type: "invalid",
                                                            children: "Password is required."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "d-grid",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_main_components_buttons_BusyBtn__WEBPACK_IMPORTED_MODULE_14__/* .BusyBtn */ .u, {
                                                        busy: (0,_main_utils_boolProp__WEBPACK_IMPORTED_MODULE_22__/* .boolProp */ .g)(isProcessing),
                                                        variant: "primary",
                                                        type: "submit",
                                                        children: "Sign in"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_auth_components_GeneralFormError__WEBPACK_IMPORTED_MODULE_11__/* .GeneralFormError */ .R, {
                                        className: "mt-1",
                                        msg: errorMsg,
                                        onClick: clearError
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: _appPath__WEBPACK_IMPORTED_MODULE_6__/* .AppPath.forgotPassword */ .j.forgotPassword,
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "small",
                            children: "I forgot my password..."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_main_components_HrWithText__WEBPACK_IMPORTED_MODULE_15__/* .HrWithText */ .C, {
                        text: "or"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_auth_components_ExternalSignIn__WEBPACK_IMPORTED_MODULE_10__/* .ExternalSignIn */ .T, {
                        disabled: isProcessing,
                        busyChanged: setIsDisabled,
                        className: "mt-2",
                        mode: "signIn"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_auth_withPublicOnly__WEBPACK_IMPORTED_MODULE_13__/* .withPublicOnly */ .o)(SignInPage));


/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 31555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCol */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;

    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }

    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{ ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 54748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ prettyBytes; }
/* harmony export */ });
const BYTE_UNITS = [
	'B',
	'kB',
	'MB',
	'GB',
	'TB',
	'PB',
	'EB',
	'ZB',
	'YB',
];

const BIBYTE_UNITS = [
	'B',
	'kiB',
	'MiB',
	'GiB',
	'TiB',
	'PiB',
	'EiB',
	'ZiB',
	'YiB',
];

const BIT_UNITS = [
	'b',
	'kbit',
	'Mbit',
	'Gbit',
	'Tbit',
	'Pbit',
	'Ebit',
	'Zbit',
	'Ybit',
];

const BIBIT_UNITS = [
	'b',
	'kibit',
	'Mibit',
	'Gibit',
	'Tibit',
	'Pibit',
	'Eibit',
	'Zibit',
	'Yibit',
];

/*
Formats the given number using `Number#toLocaleString`.
- If locale is a string, the value is expected to be a locale-key (for example: `de`).
- If locale is true, the system default locale is used for translation.
- If no value for locale is specified, the number is returned unmodified.
*/
const toLocaleString = (number, locale, options) => {
	let result = number;
	if (typeof locale === 'string' || Array.isArray(locale)) {
		result = number.toLocaleString(locale, options);
	} else if (locale === true || options !== undefined) {
		result = number.toLocaleString(undefined, options);
	}

	return result;
};

function prettyBytes(number, options) {
	if (!Number.isFinite(number)) {
		throw new TypeError(`Expected a finite number, got ${typeof number}: ${number}`);
	}

	options = {
		bits: false,
		binary: false,
		...options,
	};

	const UNITS = options.bits
		? (options.binary ? BIBIT_UNITS : BIT_UNITS)
		: (options.binary ? BIBYTE_UNITS : BYTE_UNITS);

	if (options.signed && number === 0) {
		return ` 0 ${UNITS[0]}`;
	}

	const isNegative = number < 0;
	const prefix = isNegative ? '-' : (options.signed ? '+' : '');

	if (isNegative) {
		number = -number;
	}

	let localeOptions;

	if (options.minimumFractionDigits !== undefined) {
		localeOptions = {minimumFractionDigits: options.minimumFractionDigits};
	}

	if (options.maximumFractionDigits !== undefined) {
		localeOptions = {maximumFractionDigits: options.maximumFractionDigits, ...localeOptions};
	}

	if (number < 1) {
		const numberString = toLocaleString(number, options.locale, localeOptions);
		return prefix + numberString + ' ' + UNITS[0];
	}

	const exponent = Math.min(Math.floor(options.binary ? Math.log(number) / Math.log(1024) : Math.log10(number) / 3), UNITS.length - 1);
	number /= (options.binary ? 1024 : 1000) ** exponent;

	if (!localeOptions) {
		number = number.toPrecision(3);
	}

	const numberString = toLocaleString(Number(number), options.locale, localeOptions);

	const unit = UNITS[exponent];

	return prefix + numberString + ' ' + unit;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,7948,423,1664,7447,5570,8600,6257,9108,9232,2809,9774,2888,179], function() { return __webpack_exec__(6821); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);